import React, { useState } from 'react';
import { Button } from '@abyss/web/ui/Button';
import { Label } from '@abyss/web/ui/Label';
import { Router } from '@abyss/web/ui/Router';
import { AlertComponent } from '@src/components/global/AlertComponent';
import { LoginController } from './Login.Controller';

const LOGIN_VISUAL_SRC = '/images/image-12.png?v=20260703';
const ESACM_ICON_SRC = '/images/image%20(8).png?v=20260520';
const OPTUM_SYMBOL_SRC = '/images/optum-logo.png';

export const Login = () => {
  const [{ LoginPost, isInitializing }] = LoginController();
  const [visualLoadFailed, setVisualLoadFailed] = useState(false);

  if (isInitializing) {
    return (
      <React.Fragment>
        <Router.MetaTags title="Login" />
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#ffffff',
          }}
        >
          <Label color="$gray6">Signing you in...</Label>
        </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <Router.MetaTags title="Login" />

      {/* Full-viewport two-column layout */}
      <div style={{ display: 'flex', minHeight: '100vh', width: '100%', backgroundColor: '#f5f7fa', position: 'relative' }}>

        {/* Optum logo — top-left overlay */}
        <img
          src={OPTUM_SYMBOL_SRC}
          alt="Optum"
          style={{
            position: 'absolute',
            top: '20px',
            left: '24px',
            width: '130px',
            height: 'auto',
            zIndex: 10,
          }}
        />

        {/* Left column — hero image (hidden on mobile) */}
        <div
          style={{
            flex: '1 1 60%',
            minHeight: '100vh',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'stretch',
          }}
        >
          {visualLoadFailed ? (
            <div style={{ flex: 1, backgroundColor: '#dde3f0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Label color="$gray6">Hero image unavailable</Label>
            </div>
          ) : (
            <img
              src={LOGIN_VISUAL_SRC}
              alt="Address cluster mapping visual"
              style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center', display: 'block' }}
              onError={() => setVisualLoadFailed(true)}
            />
          )}
        </div>

        {/* Right column — login card */}
        <div
          style={{
            flex: '0 0 380px',
            minWidth: '320px',
            maxWidth: '420px',
            minHeight: '100vh',
            backgroundColor: '#ffffff',
            boxShadow: '-6px 0 24px rgba(0,0,0,0.08)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            padding: '48px 40px',
            boxSizing: 'border-box',
          }}
        >
          {/* Brand mark */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '6px' }}>
            <img
              src={ESACM_ICON_SRC}
              alt="ACM icon"
              style={{ width: '44px', height: '44px', objectFit: 'contain', flexShrink: 0 }}
            />
            <span
              style={{
                fontSize: '52px',
                fontWeight: 900,
                lineHeight: 1,
                color: '#192f54',
                letterSpacing: '-0.5px',
              }}
            >
              ACM
            </span>
          </div>

          {/* Subtitle */}
          <p
            style={{
              margin: '0 0 40px 0',
              fontSize: '13px',
              fontWeight: 600,
              color: '#5a6a85',
              letterSpacing: '0.6px',
              textTransform: 'uppercase',
            }}
          >
            Address Cluster Mapping
          </p>

          {/* Divider */}
          <div style={{ width: '48px', height: '3px', backgroundColor: '#196ecf', borderRadius: '2px', marginBottom: '32px' }} />

          {/* Login heading */}
          <p
            style={{
              margin: '0 0 24px 0',
              fontSize: '28px',
              fontWeight: 800,
              color: '#002677',
              letterSpacing: '0.5px',
            }}
          >
            Sign In
          </p>

          {/* Employee Login button */}
          <Button
            css={{
              width: '100%',
              height: '48px',
              fontSize: '15px',
              fontWeight: 700,
              letterSpacing: '0.3px',
              borderRadius: '6px',
            }}
            onClick={LoginPost}
          >
            Employee Login
          </Button>

          {/* Alert below button */}
          <div style={{ marginTop: '20px' }}>
            <AlertComponent />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
